import { PremuimState,  GetPremiumResponse, SetPremiumRequest } from "Application/models";
import { fetchPremium, setPricingOnPlan } from "Application/service";
import { create } from "zustand";

export const usePremiumStore = create<PremuimState>((set) => ({
  isLoading: false,
  isError: false,
  error: null,
  getPremiumData: [],
  setPremiumData:[],

  getPremium: async (planId:any) => {
    set({ isLoading: true });

    try {
      const response: GetPremiumResponse = await fetchPremium(planId);

      set({isError: false, error: null, getPremiumData: response });

    } catch (error) {
        set({ error: 'Failed to get countries', isError: true });
        throw error;
    } finally {
      set({ isLoading: false });
    }
    
  },

  // to do

 setPremium: async (setPremiumData: SetPremiumRequest, planId:any) => {
    set({ isLoading: true });

    try {
      await setPricingOnPlan(setPremiumData, planId);
      set({ isError: false, error: null });
      await usePremiumStore.getState().getPremium(planId); // Refresh the list after creating a plan
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      set({ error: errorMessage, isError: true });
    } finally {
      set({ isLoading: false });
    }
  }

}));